import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router";
import SuccessPage from "./SuccessPage";
import "../style.css";
import ErrorResult from "./ErrorPage/errorResult";
import { useDispatch, useSelector } from "react-redux";
import { withScroll } from "../../../HOC";
import CignaLoader from "../../../UI/CignaLoader";
import { FIBE_DISBURSEMENT, FIBE_ORDER_STATUS } from "../../../Services/endpoints";
import { decrypt } from "../../../Services/AESEncryptionDecryption";
import { postApi, postApiCustom } from "../../../Services/apiService";
import { SET_LOAN_NUMBER } from "../../../Redux/PolicyNumber/types";
import { getURlParameter } from "../../../Utils";


const STATUS = {
  1 : "Processing Your Request...",
  2: "Finalizing loan disbursement...",
  3: "Renewing your health insurance...",
  4: "Almost there! It’s just taking a little longer than usual today..." 
}
const RedirectBackPage = () => {
  const dispatch = useDispatch();
  const { journeyType } = useParams();
  const { loanNumber, name, policyUserName,savePaymentDetails } = useSelector((state) => state.policyDetails);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failStatus, setFailStatus] = useState(null);
  const [errorPathType, setErrorPathType] = useState("");
  const [loadingMessage, setLoadingMessage] = useState(1);
  const [appNo, setAppNo] = useState(null)
  let {
    policyNumber,
    proposalNumber,
  } = savePaymentDetails || {};

  const fibeDisbursement = async (response,isRetry = false) => {
    const reqObj = {
      encodedString: response
    }
    try {
    //  let result = await postApiCustom(FIBE_DISBURSEMENT, reqObj, {hideLoader: true});
      let result = await postApi(FIBE_DISBURSEMENT, reqObj, {
        headers: {
          'Accept': 'application/json, text/plain',
        }
      });
      result = result?.data?.response
      if(result?.status === 200 && result?.response){
        // Step 2: Finalizing loan disbursement
        const decryptedRes = JSON.parse(decrypt(result?.response))
        dispatch({type: SET_LOAN_NUMBER, payload: {loanNumber:  decryptedRes?.loanNumber,policyUserName:decryptedRes?.policyUserName}})
        setLoading(false);
        setLoadingMessage(1);
        setSuccess(true);
      }
      else {
        setLoading(false);
        setFailStatus(result?.error);
        setErrorPathType("DISBURSED");
      }
    } catch (err) {
      if ((err?.code === "ERR_NETWORK" || err?.message === "Network Error") && !isRetry) {
        setLoadingMessage(4);
        return await fibeDisbursement(response, false);
      } else {
        setLoading(false);
        setFailStatus({
          errorCode: "500",
          errorMessage: "We are facing some issue at the moment, Please contact to manipal cigna customer care"
        });
        setErrorPathType("DISBURSED");
      }
    }
  }
  const fibeOrderStatus = async (data) => {
    const reqObj = {
      encodedString: data,
    };
    try {
    //  let result = await postApi(FIBE_ORDER_STATUS, reqObj);
      let result = await postApi(FIBE_ORDER_STATUS, reqObj, {
        headers: {
          'Accept': 'application/json, text/plain',
        }
      });
       result = result.data.response
      if(result?.status === 200 && result?.response){
        // Step 2: Finalizing loan disbursement
        setLoadingMessage(2);
        setTimeout(() => {
        // Step 3: Renewing
          setLoadingMessage(3);
          fibeDisbursement(result?.response);
        }, 1000);
      }
      else {
        setLoading(false);
        setFailStatus(result?.error);
        setErrorPathType("ORDER");
      }
    } catch (err) {
      setLoading(false);
      setFailStatus({
        errorCode: "500",
        errorMessage:  "We are facing some issue at the moment, Please contact to manipal cigna customer care"
      });
      setErrorPathType("ORDER");
    }
  }

  useEffect(() => {
    if (getURlParameter("fibe_data")) {
      setLoading(true);
      setAppNo(getURlParameter("applicationNumber"))
      fibeOrderStatus(getURlParameter("fibe_data"));
    }
    if (searchParams?.has('fibe_data')) {
      searchParams.delete('fibe_data'); 
      searchParams.delete('applicationNumber'); 
      setSearchParams(searchParams);
    }
    else{
      setFailStatus({
        errorCode: "404",
        errorMessage: "Sorry, the page you visited does not exist."
      })
    }
  }, []);

  return (
    <div style={{ minHeight: "60vh" }}>
      {/* 1. CUSTOM LOADING STATE (Enhanced Visuals) */}
      <CignaLoader loading={loading} loadingMessage={STATUS[loadingMessage]} />
      {/* 2. SUCCESS STATE (The page user sees after loading) */}
      {!loading && success ? <SuccessPage name={policyUserName || name} loanNumber={loanNumber} appNo={(policyNumber !== "" ? policyNumber : proposalNumber) || appNo} /> : null}
      <ErrorResult errorPathType={errorPathType} show={Boolean(failStatus)} status={failStatus} />
    </div>
  );
};

export default withScroll(RedirectBackPage);
